/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[check-box-error][_nghost-%COMP%]   *[_ngcontent-%COMP%] > {margin-left:25px}"];
export { styles as styles };
